import { useEffect, useRef, useState } from 'react'

export function useDebounce(onTimeout: () => void, debounceTime: number, debounceOn: unknown[] = []) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>()
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => onTimeout(), debounceTime)
  }, debounceOn) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [ debouncedValue, setDebouncedValue ] = useState(value)

  useEffect(() => {
    if (delay === 0) return
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  if (delay === 0) return value

  return debouncedValue
}